import React from 'react';
import './App.css';
import { WorkflowList } from './components/WorkflowList';

const App: React.FC = () => {
  return (
    <div className="app">
      <WorkflowList />
    </div>
  );
};

export default App;
